export const convertWeekDayMaskToDays = (wdayMask: number): number[] => {
  const selectedIndexes = (wdayMask || 0).toString(2).split("").reverse();
  return selectedIndexes.reduce(
    (result, current, index) => (current === "1" ? [...result, index] : result),
    []
  );
};
export const convertToWeekDayMask = (repeatDays: number[] = []) =>
  repeatDays.map((i) => Math.pow(2, i)).reduce((curr, acc) => curr + acc, 0);
